import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { alertErrorMessage } from "../../../customComponents/CustomAlertMessage";
import { ApiConfig } from "../../../api/apiConfig/apiConfig";
import "swiper/css";
import "swiper/css/pagination";
import AuthService from "../../../api/services/AuthService";
import { SocketContext } from "../../../customComponents/SocketContext";
import { Helmet } from "react-helmet-async";
import LoaderHelper from "../../../customComponents/Loading/LoaderHelper";

const Market = () => {
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  const [search, setsearch] = useState("");
  const [favCoins, setfavCoins] = useState([]);
  const [coinData, setCoinData] = useState([]);
  const [fiterPairData, setFiterPairData] = useState([]);
  const [topGainers, setTopGainers] = useState([]);
  const [topLosers, setTopLosers] = useState([]);
  const { socket } = useContext(SocketContext);
  const [activeTab, setActiveTab] = useState("Spot");



  useEffect(() => {
    let interval;
    if (socket) {
      let payload = {
        'message': 'market',
      }
      socket.emit('message', payload);
      interval = setInterval(() => {
        let payload = {
          'message': 'market',
        }
        socket.emit('message', payload);
      }, 2000)

      socket.on('message', (data) => {
        setCoinData(data?.pairs);
        const topGainers = [...data?.pairs || []]
        .sort((a, b) => b.change_percentage - a.change_percentage)
        const topLosers = [...data?.pairs || []]
        .sort((a, b) => a.change_percentage - b.change_percentage)
        .slice(0, 4);        setTopGainers(topGainers);
        setTopLosers(topLosers);
      });
    }
    return (() => {
      clearInterval(interval)
    })
  }, [socket]);


  useEffect(() => {
    favoriteList();
  }, []);






  const nextPage = (data) => {
    sessionStorage.setItem('RecentPair', JSON.stringify(data))
    navigate(`/trade/${data?.base_currency}_${data?.quote_currency}`);
  };

  const handleAddFav = async (pairId) => {
    LoaderHelper.loaderStatus(true)
    await AuthService.favoriteCoin(pairId).then((result) => {
      if (result.success) {
        try {
          favoriteList();
        } catch (error) {
          alertErrorMessage(result?.message)
        }
      } else {
        alertErrorMessage(result.message);
      }
    });
    LoaderHelper.loaderStatus(false)
  };

  const favoriteList = async () => {
    await AuthService.favoriteList().then((result) => {
      if (result?.success) {
        try {
          setfavCoins(result?.data?.pairs ? result?.data?.pairs : []);
        } catch (error) {
          alertErrorMessage(result?.message)
        }
      }
    });
  };

  useEffect(() => {
    let filteredData = coinData?.filter((item) => {
      return (
        item?.base_currency?.toLowerCase().includes(search?.toLowerCase()) ||
        item?.quote_currency?.toLowerCase().includes(search?.toLowerCase())
      );
    });
    setFiterPairData(filteredData);
  }, [search, coinData]);

  const gainerElementRef = useRef(null);


  const handleTabClick = (itemName) => {
    setActiveTab(itemName);
    if (gainerElementRef.current) {
      gainerElementRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <>
     <Helmet>
    <title>Vorienx Market – Live Crypto Prices & Trading Pairs</title>

    <meta
        name="description"
        content="Explore live market data on Vorienx. View real-time prices, volumes and trading pairs for Bitcoin, Ethereum and top altcoins. Start trading today."
    />

    <meta
        name="keywords"
        content="crypto market, live crypto prices, bitcoin ethereum trading pairs, Vorienx market"
    />
</Helmet>

      <section className="section-padding login_bg  login_sec  market_page">
        <section className="live_prices mt-0 market_prices market_update_sec market_update_table ">
          <div className="container">
            <div className="row mb-4 g-2">

              {/* Biggest Gainers */}

              <div className="col-lg-3">
                <div className="ant-card ant-card-bordered ant-card-small marketRankList_rankItem__L1CvR">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">
                      <h3>
                        <span className="bvtPSA me-2"  >
                          <img src="/images/topgainer_icon.svg" className="img-fluid" width="21" height="21" alt="top gainers" />
                        </span>
                        Top Gainers
                      </h3>
                    </div>
                    <button type="button" className="btn btn-link" onClick={() => handleTabClick('Gainers')}> See more <i className="ri-arrow-right-s-line"></i></button>
                  </div>

                  <div className="ant-card-body">
                    <div className="mt_table" >
                      <table className="table" >
                        <thead>
                          <tr>
                            {/* <th>#</th> */}
                            <th>Name</th>
                            <th className="text-end">Price</th>
                            <th className="text-end">24h</th>
                          </tr>
                        </thead>
                        <tbody>
                          {topGainers.length <= 0 ?
                            <tr >
                              <td colSpan="4" className="p-0" >
                                <div className="loading-wave-market">
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                </div>
                              </td>
                            </tr> :
                            topGainers
                              ? topGainers
                                .slice(0, 4).map((item, index) => {
                                  return <tr key={index}  onClick={() => nextPage(item)} >
                                    <td>
                                      <div className="spotName">
                                        <div className="symblecurrency">
                                        <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg" />
                                          {item?.base_currency}/{item?.quote_currency} <span className="text-muted"></span>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="text-end">{parseFloat(item?.buy_price?.toFixed(5))}</td>
                                    <td className={item?.change_percentage >= 0 ? "text-success text-end" : "text-danger text-end"} ><b>
                                      <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                      {parseFloat(item?.change_percentage?.toFixed(5))}%</b>
                                    </td>
                                  </tr>
                                })
                              : (
                                <tr >
                                  <td colSpan="4" className="p-0" >
                                    <div className="favouriteData">
                                      <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                                      <p>No Data Available</p>
                                    </div>
                                  </td>
                                </tr>
                              )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {/* Biggest Losers */}
              <div className="col-lg-3">
                <div className="ant-card ant-card-bordered ant-card-small marketRankList_rankItem__L1CvR">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">
                      <h3>
                        <span className="bvtPSA bvtPSAL me-2"  >
                          <img src="/images/biggest_losser_icon.svg" className="img-fluid" width="21" height="21" alt="top losers" />
                        </span>
                        Top Losers
                      </h3>
                    </div>
                    <button type="button" className="btn btn-link" onClick={() => handleTabClick('Losers')}> See more <i className="ri-arrow-right-s-line"></i></button>
                  </div>
                  <div className="ant-card-body">
                    <div className="mt_table" >
                      <table className="table" >
                        <thead>
                          <tr>
                            {/* <th>#</th> */}
                            <th>Name</th>
                            <th className="text-end" >Price</th>
                            <th className="text-end" >24h</th>
                          </tr>
                        </thead>
                        <tbody>

                          {topLosers && topLosers.length <= 0 ?
                            <tr >
                              <td colSpan="4" className="p-0" >
                                <div className="loading-wave-market">
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                </div>
                              </td>
                            </tr> :
                            topLosers
                              ? topLosers.slice(0, 4).map((item, index) => {
                                return (
                                  <tr key={index}  onClick={() => nextPage(item)} >
                                    <td>
                                      <div className="spotName">
                                        <div className="symblecurrency">
                                        <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg" />
                                          {item?.base_currency}/{item?.quote_currency} <span className="text-muted"></span>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="text-end">{parseFloat(item?.buy_price?.toFixed(5))}</td>
                                    <td className={item?.change_percentage >= 0 ? "text-danger text-end" : "text-danger text-end"} ><b>
                                      <i className={item?.change_percentage >= 0 ? "ri-arrow-down-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                      {parseFloat(item?.change_percentage?.toFixed(5))}%</b>
                                    </td>
                                  </tr>
                                );
                              })
                              : (
                                <tr >
                                  <td colSpan="4" className="p-0" >
                                    <div className="favouriteData">
                                      <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                                      <p>No Data Available</p>
                                    </div>
                                  </td>
                                </tr>
                              )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {/* Trending */}
              <div className="col-lg-3">
                <div className="ant-card ant-card-bordered ant-card-small marketRankList_rankItem__L1CvR">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">
                      <h3>
                        <span className="bvtPSA bvtPSAL me-2"  >
                          <img src="/images/trending_icon.svg" className="img-fluid" width="21" height="21" alt="trending" />
                        </span> Trending</h3>
                    </div>
                    <button type="button" className="btn btn-link" onClick={() => handleTabClick('Trending')}> See more <i className="ri-arrow-right-s-line"></i></button>
                  </div>
                  <div className="ant-card-body">

                    <div className="mt_table" >
                      <table className="table" >
                        <thead>
                          <tr>
                            {/* <th>#</th> */}
                            <th>Name</th>
                            <th className="text-end" >Price</th>
                            <th className="text-end" >24h</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coinData && coinData.length <= 0 ?
                            <tr >
                              <td colSpan="4" className="p-0" >
                                <div className="loading-wave-market">
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                </div>
                              </td>
                            </tr> :
                            coinData && coinData?.length > 0 ? (
                              coinData?.slice(0, 4)?.map((item, index) => {
                                return (
                                  <tr key={index}  onClick={() => nextPage(item)} >
                                  <td>
                                    <div className="spotName">
                                      <div className="symblecurrency">
                                      <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg" />
                                        {item?.base_currency}/{item?.quote_currency} <span className="text-muted"></span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-end">{parseFloat(item?.buy_price?.toFixed(5))}</td>
                                  <td className={item?.change_percentage >= 0 ? "text-success text-end" : "text-danger text-end"} ><b>
                                    <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                    {parseFloat(item?.change_percentage?.toFixed(5))}%</b>
                                  </td>
                                </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="4" className="p-0">
                                  <div className="favouriteData">
                                    <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                                    <p>No Data Available</p>
                                  </div>
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="ant-card ant-card-bordered ant-card-small marketRankList_rankItem__L1CvR">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">
                      <h3>
                        <span className="bvtPSA bvtPSAL me-2"  >
                          <img src="images/new_coin_icon.png" alt="new coin"></img></span> New Coins</h3>
                    </div>
                    <button type="button" className="btn btn-link" onClick={() => handleTabClick('Trending')}> See more <i className="ri-arrow-right-s-line"></i></button>
                  </div>
                  <div className="ant-card-body">
                    <div className="mt_table" >
                      <table className="table" >
                        <thead>
                          <tr>
                            {/* <th>#</th> */}
                            <th>Name</th>
                            <th className="text-end" >Price</th>
                            <th className="text-end" >24h</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coinData && coinData.length <= 0 ?
                            <tr >
                              <td colSpan="4" className="p-0" >
                                <div className="loading-wave-market">
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                  <div className="loading-bar"></div>
                                </div>
                              </td>
                            </tr> :
                            coinData && coinData?.length > 0 ? (
                              coinData?.reverse()?.slice(0, 4)?.map((item, index) => {
                   
                                // }
                                return (
                                  <tr key={index} onClick={() => nextPage(item)} >
                                  <td>
                                    <div className="spotName">
                                      <div className="symblecurrency">
                                      <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg" />
                                        {item?.base_currency}/{item?.quote_currency} <span className="text-muted"></span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-end">{parseFloat(item?.buy_price?.toFixed(5))}</td>
                                  <td className={item?.change_percentage >= 0 ? "text-success text-end" : "text-danger text-end"} ><b>
                                    <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                    {parseFloat(item?.change_percentage?.toFixed(5))}%</b>
                                  </td>
                                </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="4" className="p-0">
                                  <div className="favouriteData">
                                    <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                                    <p>No Data Available</p>
                                  </div>
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container" ref={gainerElementRef}>
            <div className="d-flex-between  mb-3  custom_dlflex">
              <ul className="nav nav-pills mb-2 overflowx_scroll funds_tab  market_tabs">
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "Fav" ? 'active' : ""}`} onClick={() => setActiveTab('Fav')}>
                    <i className="ri-star-s-line me-2 ri-xl"></i> favourite
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "Spot" ? 'active' : ""}`} onClick={() => setActiveTab('Spot')}>
                    <i className="ri-list-unordered ri-xl me-2"></i> Spot
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "Gainers" ? 'active' : ""}`} onClick={() => setActiveTab('Gainers')}>
                    <i className="ri-arrow-right-up-line me-2"></i>
                    Gainers
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "Losers" ? 'active' : ""}`} onClick={() => setActiveTab('Losers')}>
                    <i className="ri-arrow-right-down-line me-2"></i>
                    Losers
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "Trending" ? 'active' : ""}`} onClick={() => setActiveTab('Trending')}>
                    <i className="ri-fire-fill me-2"></i> Trending
                  </button>
                </li>
              </ul>
              {
                activeTab === "Fav" || activeTab === "Spot" ?
                  <div className="searchBar custom-tabs">
                    <i className="ri-search-2-line"></i>
                    <input type="search" className="custom_search" placeholder="Search Crypto" value={search} onChange={(e) => { setsearch(e.target.value); }} />
                  </div>
                  :
                  ""
              }
            </div>
            <div className="tab-content custom-tab-content p-0">
              {/* Favourite */}
              <div className={`tab-pane ${activeTab === "Fav" ? 'active' : ""}`}>
                <div className="card py-2">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      {token ? (
                        (favCoins?.length > 0) ?
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Pair</th>
                                <th>Price</th>
                                <th>24H Change</th>
                                <th>24H High</th>
                                <th>24H Low</th>
                                <th>24H Vol</th>
                                <th>Chart</th>
                                <th>Operation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {fiterPairData && fiterPairData.map((item, index) => {
                                // if (!favCoins.includes(item?._id)) return null;
                                return (
                                  favCoins.includes(item?._id) &&
                                  <tr key={index} onClick={() => nextPage(item)} >
                                    <td>
                                      <div className="td_div">
                                        <span className="star_btn btn_icon active">
                                          <i className="ri-star-fill text-warning me-2" onClick={() => { handleAddFav(item?._id); }}></i>
                                        </span>
                                        <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg me-2" />
                                        {item?.base_currency}/{item?.quote_currency}
                                      </div>
                                    </td>
                                    <td><b>{parseFloat(item?.buy_price?.toFixed(5))}</b></td>
                                    <td className={item?.change >= 0 ? "color-green green" : "color-red text-danger"}><b>{parseFloat(item?.change?.toFixed(5))}</b> </td>
                                    <td><b>{parseFloat(item?.high?.toFixed(5))}</b></td>
                                    <td><b>{parseFloat(item?.low?.toFixed(5))}</b></td>
                                    <td><b>{parseFloat(item?.volume?.toFixed(5))}</b></td>
                                    <td><img src="/images/trade_count_range.svg" alt="svg" /></td>
                                    <td><a href="javascript:void(0)" onClick={() => nextPage(item)} className="btn custom-btn btn-sm" ><span>Trade</span></a></td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          :
                          <div className="favouriteData">
                            <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                            <p>No Data Available</p>
                          </div>
                      ) : (
                        <div className="py-5 favouriteData">
                          <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                          <p className="mt-2">No results.... Go to&nbsp;
                            <Link className="btn-link" to="/login"><b>&nbsp; Sign in &nbsp;</b></Link>&nbsp;and add your favorite coins from Spot.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Spot */}
              <div className={`tab-pane ${activeTab === "Spot" ? 'active' : ""}`}>
                <div className="card  py-2 spot_table">
                  <div className="card-body p-0">
                    <div className="mrt_row">
                    </div>
                    <div className="table-responsive">
                      {fiterPairData?.length > 0 ? (
                        <table className="table ">
                          <thead>
                            <tr>
                              <th> Pair</th>
                              <th> Price</th>
                              <th> 24H Change</th>
                              <th> 24H High</th>
                              <th> 24H Low</th>
                              <th> 24H Vol</th>
                              {/* <th> Chart</th> */}
                              <th> Operation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fiterPairData ? fiterPairData.map((item, index) => (
                              <tr key={index} onClick={() => nextPage(item)} >
                                <td>
                                  <div className="td_div">
                                    {token && (
                                      <span className={"star_btn btn_icon active"}>
                                        <i className={favCoins.includes(item?._id) ? "ri ri-star-fill text-warning me-2 " : "ri ri-star-line me-2 "} onClick={() => { handleAddFav(item?._id); }} ></i>
                                      </span>
                                    )}
                                    <img alt="" src={ApiConfig.baseImage + item?.icon_path} className="img-fluid icon_img coinimg me-2 " />
                                    {item?.base_currency}/
                                    {item?.quote_currency}
                                  </div>
                                </td>
                                <td><b>{parseFloat(item?.buy_price?.toFixed(5))}</b> </td>
                                <td className={item?.change >= 0 ? "color-green text-green" : "color-red text-danger"} ><b>{parseFloat(item?.change?.toFixed(5))}</b></td>
                                <td className=" color-green"><b>{parseFloat(item?.high?.toFixed(5))}</b></td>
                                <td className="text-danger"><b>{parseFloat(item?.low?.toFixed(5))}</b></td>
                                <td><b>{parseFloat(item?.volume?.toFixed(5))}</b></td>
                                {/* <td>
                                <img src={item?.change >= 0 ? "/images/trade_count_range.svg" : "/images/trade_count_red.svg"} alt="svg" /> 
        
                                  </td> */}
                                <td> <span onClick={() => nextPage(item)} className="btn custom-btn btn-sm cursor-pointer"><span>Trade</span></span></td>
                              </tr>
                            ))
                              : null
                            }
                          </tbody>
                        </table>
                      ) : (
                        <div className="favouriteData">
                          <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                          <p>No Data Available</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Biggest Gainers */}
              <div className={`tab-pane ${activeTab === "Gainers" ? 'active' : ""}`}>
                <div className="card  py-2">
                  <div className="card-body p-0 gainers_table">
                    <div className="table-responsive">
                      {topGainers && topGainers?.length > 0 ? (
                        <>
                          {/* <h5 className="text-center">Biggest Gainers</h5> */}
                          <table className="table ">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th className="name"> Pair</th>
                                <th> Price</th>
                                <th> 24H </th>
                                <th> Volume(24H)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {topGainers
                                ? topGainers
                                  .map((item, index) => {
                                    return <tr key={index} onClick={() => nextPage(item)}  >
                                      <td className="">
                                        {index+1}
                                      </td>
                                      <td>
                                        <div className="td_div">
                                          {item?.base_currency}
                                          <small>&nbsp; | {item?.symbol}</small>&nbsp;
                                          {item?.quote_currency}
                                        </div>
                                      </td>
                                      <td><b>{parseFloat(item?.buy_price?.toFixed(5))}</b></td>
                                      <td className={item?.change_percentage >= 0 ? "color-green text-green" : "color-red text-danger"} ><b>
                                        <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                        {parseFloat(item?.change_percentage?.toFixed(5))}%</b> </td>
                                      <td> <b> {parseFloat((item?.volume)?.toFixed(5))} </b> </td>
                                    </tr>
                                  })
                                : null
                              }
                            </tbody>
                          </table> </>
                      ) : (
                        <div className="favouriteData">
                          <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                          <p>No Data Available</p>
                        </div>
                      )
                      }
                    </div>
                  </div>
                </div>
              </div>

              {/* Biggest Losers */}
              <div className={`tab-pane ${activeTab === "Losers" ? 'active' : ""}`}>
                <div className="card  py-2">
                  <div className="card-body p-0 losers_table">
                    <div className="table-responsive">
                      {
                        topLosers && topLosers?.length > 0 ? (
                          <>
                            {/* <h5 className="text-center">Biggest Losers</h5> */}
                            <table className="table ">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th className="name"> Name</th>
                                  <th> Price</th>
                                  <th> 24H </th>
                                  <th> Volume(24H)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {topLosers
                                  ? topLosers.map((item, index) => {
                                    return  <tr key={index}  onClick={() => nextPage(item)} >
                                    <td className="">
                                      {index+1}
                                    </td>
                                    <td>
                                      <div className="td_div">
                                        {item?.base_currency}
                                        <small>&nbsp; | {item?.symbol}</small>&nbsp;
                                        {item?.quote_currency}
                                      </div>
                                    </td>
                                    <td><b>{parseFloat(item?.buy_price?.toFixed(5))}</b></td>
                                    <td className={item?.change_percentage >= 0 ? "color-green text-green" : "color-red text-danger"} ><b>
                                      <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                      {parseFloat(item?.change_percentage?.toFixed(5))}%</b> </td>
                                    <td> <b> {parseFloat((item?.volume)?.toFixed(5))} </b> </td>
                                  </tr>
                                  })
                                  : null
                                }
                              </tbody>
                            </table> </>
                        ) : (
                          <div className="favouriteData">
                            <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                            <p>No Data Available</p>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>

              {/* Trending */}
              <div className={`tab-pane ${activeTab === "Trending" ? 'active' : ""}`}>
                <div className="card  py-2">
                  <div className="card-body p-0 trending_table">
                    <div className="table-responsive">
                      {
                        coinData && coinData?.length > 0 ? (
                          <>
                            {/* <h5 className="text-center"> Top Trending</h5> */}
                            <table className="table ">
                              <thead>
                                <tr>
                                  <th> #</th>
                                  <th> Name</th>
                                  <th> Price</th>
                                  <th> 24H </th>
                                  <th>	Volume(24H)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {coinData?.reverse().map((item, index) => {
                      
                                  return (
                                    <tr key={index} onClick={() => nextPage(item)} >
                                      <td className="">
                                        {index+1}
                                      </td>
                                      <td>
                                        <div className="td_div">
                                          {item?.base_currency}
                                          <small>&nbsp; | {item?.symbol}</small>&nbsp;
                                          {item?.quote_currency}
                                        </div>
                                      </td>
                                      <td><b>{parseFloat(item?.buy_price?.toFixed(5))}</b></td>
                                      <td className={item?.change_percentage >= 0 ? "color-green text-green" : "color-red text-danger"} ><b>
                                        <i className={item?.change_percentage >= 0 ? "ri-arrow-up-s-fill me-1" : "ri-arrow-down-s-fill me-1"}></i>
                                        {parseFloat(item?.change_percentage?.toFixed(5))}%</b> </td>
                                      <td> <b> {parseFloat((item?.volume)?.toFixed(5))} </b> </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <div className="favouriteData">
                            <img src="/images/no_data_vector.svg" className="img-fluid" width="96" height="96" alt="" />
                            <p>No Data Available</p>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section >
    </>
  );
};

export default Market;
